// store/modules/system.js
import apiClient from '@/api/index';
import { setLoading } from '@/plugins/loading';

const state = {
    logo: null,
    title: 'Default Title',
    defaultLocale: 'en',
    isUserRegistrationEnabled: false,
    isUserClubInvitationEnabled: false,
    isUserClubKickoutEnabled: false,
};

const getters = {
    logo: state => state.logo,
    title: state => state.title,
    defaultLocale: state => state.defaultLocale,
    isUserRegistrationEnabled: state => state.isUserRegistrationEnabled,
    isUserClubInvitationEnabled: state => state.isUserClubInvitationEnabled,
    isUserClubKickoutEnabled: state => state.isUserClubKickoutEnabled,
};

const mutations = {
    SET_LOGO(state, logo) {
        state.logo = logo;
    },
    SET_TITLE(state, title) {
        state.title = title;
    },
    SET_DEFAULT_LANG(state, lang) {
        state.defaultLocale = lang;
    },
    SET_USER_REGISTRATION_ENABLED(state, isEnabled) {
        state.isUserRegistrationEnabled = isEnabled;
    },
    SET_USER_CLUB_INVITATION_ENABLED(state, isEnabled) {
        state.isUserClubInvitationEnabled = isEnabled;
    },
    SET_USER_CLUB_KICKOUT_ENABLED(state, isEnabled) {
        state.isUserClubKickoutEnabled = isEnabled;
    },
    CLEAR_LOGO(state) {
        state.logo = null;
    },
};
const actions = {
    async fetchTenantInfo({ commit }) {
        setLoading(true);
        try {
            const response = await apiClient.get('configs/tenant/self', {
                skipAuthorization: true,
            });
            processTenantInfo(commit, response.data);
            return response;
        } catch (error) {
            console.error(
                'Error fetching tenant info:',
                error.response,
                error.config
            );
            throw error;
        } finally {
            setLoading(false);
        }
    },
    async fetchTenantInfoClearCache({ commit }) {
        setLoading(true);
        try {
            const response = await apiClient.get(
                'configs/tenant/self?disable_cache=true',
                { skipAuthorization: true }
            );
            processTenantInfo(commit, response.data);
            return response;
        } catch (error) {
            console.error(
                'Error fetching tenant info clear cache:',
                error.response,
                error.config
            );
            throw error;
        } finally {
            setLoading(false);
        }
    },
};

// Helper function to process the response data
function processTenantInfo(commit, data) {
    const currentLanguage =
        localStorage.getItem('locale') || data.language_code;
    commit('SET_LOGO', data.logo);
    commit('SET_DEFAULT_LANG', data.language_code);
    commit('SET_TITLE', data.title[currentLanguage]);
    commit('SET_USER_REGISTRATION_ENABLED', data.is_user_registration_enabled);
    commit(
        'SET_USER_CLUB_INVITATION_ENABLED',
        data.is_user_club_invitation_enabled
    );
    commit('SET_USER_CLUB_KICKOUT_ENABLED', data.is_user_club_kickout_enabled);
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
